import API from '../api'
import postUrl from './paths'

export const generateCranReportApi = ({ inspectionReportId, organisationId, probeId, userId }) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.generateCranReport, {}, { inspectionReportId, organisationId, probeId, userId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

// Brief vs detailed probe report — `isBrief` decides which one the backend generates.
export const generateProbeReportApi = ({ probeId, userId, isBrief }) =>
	new Promise((resolve, reject) => {
		// `null` body: the API layer only injects userId / organisationId / created_by into a non-null
		// body, and this endpoint takes everything as query params. The endpoint's own param is named
		// probe42Id.
		API.post(postUrl.generateProbeReport, null, { probe42Id: probeId, userId, isBrief })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const addCommentInCranReport = ({ probe42Id, userId, commentValue, commentKey }) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.addCranComment, commentValue, { probe42Id, userId, commentKey })
			.then((response) => {
				resolve(response)
			})
			.catch((error) => {
				reject(error)
			})
	})

// Images attached to one CRAN comment. The endpoint takes a single file per call, so a multi-file
// pick is sent as one request per image.
export const uploadCranCommentDocument = ({ file, probe42Id, userId, commentKey }) =>
	new Promise((resolve, reject) => {
		const formData = new FormData()
		formData.append('file', file)
		API.post(postUrl.uploadCranCommentDocument, formData, { probe42Id, userId, commentKey })
			.then((response) => {
				resolve(response?.data ?? response)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const saveInspectionReportApi = (organisationId, report, userId, inspectionReportId = null) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.saveInspectionReport, { ...report }, { organisationId, userId, inspectionReportId })
			.then((response) => {
				resolve(response)
			})
			.catch((error) => {
				reject(error)
			})
	})

// voter id will be null in case we need to add document to overall voting object
export const addVotingDocument = (files, organisationId, userId, voterId) =>
	new Promise((resolve, reject) => {
		const formData = new FormData()
		files.forEach((file) => {
			formData.append('files', file)
		})
		API.post(postUrl.addVotingDocument, formData, { organisationId, userId, voterId })
			.then((response) => {
				resolve(response)
			})
			.catch((error) => {
				reject(error)
			})
	})
